import { lazy, useState, useEffect, useRef } from 'react';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Spinner,
} from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import qs from 'query-string';
import history from 'src/history';
import Alert from 'src/componentes/message-box/alert';

import { getConfiguration } from 'src/services/commonRequests';
import Edit from 'src/componentes/edit/edit-dialog';
import ContentManager from 'src/componentes/content-manager';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import { capitalizeFirstLetter, lowerCaseFirstLetter } from 'src/utils/string';
import ValidarRestricaoNovo from 'src/componentes/validar-restricao-novo/ValidarRestricao';
import errorHandler from 'src/utils/error-handler';
import LucideIcon from 'src/componentes/lucide-icon';
import DropdownItemRisco from 'src/paginas/gestao-risco/risco/RiscoListView/DropdownItemRisco';
import Acao from 'src/paginas/NewGantt';
import Button from 'src/componentes/button';
import PanelCollapse from 'src/componentes/panel-collapse';

import RiscoAvaliacao from '../Avaliacao/AvaliacaoListView';
import Resumo from './Resumo';
import RiscoPontosProblematicos from './RiscoPontoControleListView';
import Graficos from '../RiscoEditView/grafico/graficos';
import Schema from './Schema';
import EventoListView from '../Evento/EventoListView';
import http from 'src/services/httpService';
import {
  TIPO_INTERACAO_SOPHIE,
  ADDONS,
  TIPO_VALOR,
  STATUS_ITEM,
} from 'src/utils/constants';
import Permissao from 'src/paginas/permissao';
import RiscoAvaliacaoPowerBIListView from 'src/paginas/gestao-risco/risco/RiscoEditView/RiscoAvaliacaoPowerBI/RiscoAvaliacaoPowerBIListView';
import useAuth from 'src/hooks/useAuth';

const AssistenteVirtual = lazy(() =>
  import('src/components/IA/ChatGPT/AssistenteVirtual')
);

const FormEdit = (props) => {
  const intl = useIntl();
  const { terms: resources, addons } = useAuth();

  const {
    model,
    disabledEdit,
    showDelete = true,
    configuracao,
    configuracaoEvento,
    handleCloseEdit,
    refreshHeaderCustom,
  } = props;

  const atualizarComponentsComKeyRandomico = () => {
    model.getModel('randomAcaoKey').requestChange &&
      model.getModel('randomAcaoKey').requestChange(Math.random());
  };

  const atualizarResumo = () => {
    model.getModel('forceRefresh').requestChange(Math.random());
  };

  const atualizarCausas = (causasAtualizadas) => {
    if (model && causasAtualizadas) {
      model.getModel('causasRisco').requestChange(causasAtualizadas);
    }
  };

  const atualizarConsequencias = (consequenciasAtualizadas) => {
    if (model && consequenciasAtualizadas) {
      model
        .getModel('consequenciasRisco')
        .requestChange(consequenciasAtualizadas);
    }
  };

  //handleClose - Parametros não usados do edit-dialog (a,b,c,d,e)
  const onClose = ({ closeModal }) => {
    if (closeModal) handleCloseEdit && handleCloseEdit(closeModal);
  };

  const closeModal = () => {
    handleCloseEdit && handleCloseEdit();
  };

  const id = model.getModel('id') && model.getModel('id').value;
  const permissions = model?.getModel('permissions')?.value;

  let disabled;
  if (disabledEdit) disabled = disabledEdit;
  else {
    disabled = permissions ? !permissions.allowEdit : false;
  }

  const statusId = model.getModel('status').value?.id;
  const existeFluxoAprovacao = model.getModel('existeFluxoAprovacao')?.value;
  const fluxoConcluidoEmStatusEditavel =
    existeFluxoAprovacao &&
    [
      STATUS_ITEM.EM_PLANEJAMENTO,
      STATUS_ITEM.ATIVO,
      STATUS_ITEM.CONCLUIDO,
      STATUS_ITEM.SUSPENSO,
      STATUS_ITEM.CANCELADO,
    ].includes(statusId);
  const disabledPendenteAprovacao =
    model.getModel('pendenteAprovacao').value &&
    !fluxoConcluidoEmStatusEditavel;
  const reprovadoFluxoAprovacao =
    model.getModel('fluxoAprovacao').value &&
    statusId == STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO;
  const reprovadoDefinitivoFluxoAprovacao =
    model.getModel('fluxoAprovacao').value && statusId == STATUS_ITEM.REPROVADO;
  const rascunhoPendenteAprovacao =
    model.getModel('fluxoAprovacao').value &&
    !existeFluxoAprovacao &&
    statusId == STATUS_ITEM.EM_PLANEJAMENTO;
  const modelo =
    model.getModel('modeloRisco') && model.getModel('modeloRisco').value;

  const isEstrategico = modelo && modelo.id == 1 ? true : false;
  const isOperacional = modelo && modelo.id == 2 ? true : false;
  const isProjeto = modelo && modelo.id == 3 ? true : false;

  const { habilitarCalculoDeScores, utilizarPermissoes } = configuracao || {};

  const modeloRisco = {
    isEstrategico: isEstrategico,
    isOperacional: isOperacional,
    isProjeto: isProjeto,
  };

  const allowDelete =
    showDelete &&
    model &&
    model.getModel('permissions').getModel('allowDelete').value;

  const isNew = !id || id < 0 || id === 0;

  const addonIntegracaoPowerBIAvaliacaoRisco =
    addons &&
    addons.find((m) => m.id === ADDONS.INTEGRACAO_POWERBI_AVALIACAORISCO)
      ?.ativo;

  return (
    <div data-testid="risco-edit-form" style={{ marginTop: 15 }}>
      {isNew ? (
        <Resumo
          modeloRisco={modeloRisco}
          model={model}
          disabled={disabled}
          configuracao={configuracao}
          parameters={props.parameters}
        />
      ) : (
        <Tabs>
          <Tab key="1" label={<FormattedMessage id="cadastro" />}>
            <Resumo
              modeloRisco={modeloRisco}
              model={model}
              disabled={
                disabled ||
                disabledPendenteAprovacao ||
                reprovadoDefinitivoFluxoAprovacao
              }
              rascunhoPendenteAprovacao={rascunhoPendenteAprovacao}
              configuracao={configuracao}
              parameters={props.parameters}
            />
          </Tab>
          {!isNew && (
            <Tab
              key="4"
              label={capitalizeFirstLetter(resources.analisederisco)}
            >
              <RiscoPontosProblematicos
                modeloRisco={modeloRisco}
                model={model}
                disabled={
                  disabledEdit ||
                  disabled ||
                  disabledPendenteAprovacao ||
                  reprovadoDefinitivoFluxoAprovacao
                }
                configuracao={configuracao}
                handleClose={onClose}
                causasRisco={model.getModel('causasRisco').value}
                consequenciasRisco={model.getModel('consequenciasRisco').value}
                onCausasUpdated={atualizarCausas}
                onConsequenciasUpdated={atualizarConsequencias}
                riscoId={id}
              />
            </Tab>
          )}
          {!isNew &&
            !reprovadoDefinitivoFluxoAprovacao &&
            !reprovadoFluxoAprovacao &&
            !disabledPendenteAprovacao &&
            !rascunhoPendenteAprovacao && (
              <Tab key="2" label={capitalizeFirstLetter(resources.avaliacoes)}>
                <PanelCollapse
                  header={capitalizeFirstLetter(resources.avaliacoes)}
                >
                  <RiscoAvaliacao
                    showDelete={allowDelete}
                    showPage={false}
                    showSearch={false}
                    exibirAcao={true}
                    showNew={true}
                    parameters={{ riscoId: id }}
                    model={model}
                    disabled={disabled}
                    funcAtualizarAnscestral={atualizarComponentsComKeyRandomico}
                    refreshHeaderCustom={refreshHeaderCustom}
                    refreshResumo={atualizarResumo}
                    habilitarCalculoDeScores={habilitarCalculoDeScores}
                    habilitarLinkRisco={false}
                    configuration={configuracao}
                    habilitarBotaoSincronizarAvaliacoes={
                      model.getModel('utilizarValorPowerBI').value
                    }
                  />
                </PanelCollapse>
                {addonIntegracaoPowerBIAvaliacaoRisco &&
                  model.getModel('utilizarValorPowerBI').value && (
                    <PanelCollapse
                      header={intl.formatMessage({ id: 'label.integracao' })}
                    >
                      <RiscoAvaliacaoPowerBIListView
                        parameters={{
                          itemId: id,
                          tipoValorId: TIPO_VALOR.REALIZADO,
                          alterado: false,
                          utilizarConfigPeriodo: false,
                        }}
                      />
                    </PanelCollapse>
                  )}
              </Tab>
            )}
          {!isNew &&
            !reprovadoDefinitivoFluxoAprovacao &&
            !reprovadoFluxoAprovacao &&
            !disabledPendenteAprovacao &&
            !rascunhoPendenteAprovacao &&
            configuracao.habilitarAcompanhamentoEventosRisco && (
              <Tab
                key={'6'}
                label={intl.formatMessage(
                  { id: 'eventosRisco' },
                  { eventosderisco: resources.eventosderisco }
                )}
              >
                <EventoListView
                  showDelete={allowDelete}
                  showPage={false}
                  showSearch={false}
                  exibirAcao={true}
                  showNew={true}
                  parameters={{ riscoId: id }}
                  model={model}
                  disabled={disabled}
                  configuracao={configuracaoEvento}
                />
              </Tab>
            )}
          {!isNew &&
            !reprovadoDefinitivoFluxoAprovacao &&
            !reprovadoFluxoAprovacao &&
            !disabledPendenteAprovacao &&
            !rascunhoPendenteAprovacao && (
              <Tab
                //força children dessa tab a ser re renderizado, atualizando o estado
                key={
                  (model.getModel('randomAcaoKey') &&
                    model.getModel('randomAcaoKey').value) ||
                  '5'
                }
                label={capitalizeFirstLetter(resources.planodeacao)}
              >
                <Acao
                  itemId={id}
                  handleCloseModal={closeModal}
                  desabilitarSincronizacao={true}
                />
              </Tab>
            )}
          {!isNew &&
            utilizarPermissoes &&
            !disabledPendenteAprovacao &&
            !reprovadoDefinitivoFluxoAprovacao &&
            !reprovadoFluxoAprovacao &&
            !rascunhoPendenteAprovacao &&
            permissions != null &&
            permissions.allowEditPermissions && (
              <Tab
                label={<FormattedMessage id="label.permissoesDeAcesso" />}
                key="7"
              >
                <Row>
                  <Col md={12}>
                    <Permissao
                      parameters={{
                        itemId: id,
                        TipoItemId: 6,
                      }}
                      disabled={disabled}
                      showPanel={false}
                    />
                  </Col>
                </Row>
              </Tab>
            )}
        </Tabs>
      )}
    </div>
  );
};

const RiscoEdit = (props) => {
  const intl = useIntl();
  const { terms: resources, user } = useAuth();

  const {
    item,
    location,
    showDelete = true,
    disabledEdit = false,
    afterSave,
    urlList,
    parameters,
    model: modelProp,
  } = props;

  const [id, setId] = useState(() => location && qs.parse(location.search).id);
  const [configuracao, setConfiguracao] = useState({});
  const [configuracaoEvento, setConfiguracaoEvento] = useState({});
  const [forceRefresh, setForceRefresh] = useState(false);
  const [enviandoAprovacao, setEnviandoAprovacao] = useState(false);
  const [, setSaved] = useState(false);

  const enviandoAprovacaoRef = useRef(false);

  useEffect(() => {
    getConfiguration('ItemConfiguracaoRisco')(setConfiguracao)();
    getConfiguration('EventoRiscoConfiguracao')(setConfiguracaoEvento)();
  }, []);

  const handleSaved = (data) => {
    setId(data.id);

    afterSave && afterSave(data);
  };

  const handleCloseEdit = (salvo) => {
    if (salvo) setSaved((prev) => !prev);
  };

  const handleDeleteClick = async (itemAtual) => {
    try {
      const parametros = { id: itemAtual.id };
      const response = await http.post('/Risco/ValidarRestricoes', parametros);
      const restricoesModel = response.data;

      ContentManager.addContent(
        <ValidarRestricaoNovo
          title="labelExcluirRisco"
          url="/Risco/ValidarRestricoes"
          urlExclusao="/Risco/AtualizarStatusExcluido"
          urlList={urlList ?? '/gerenciar/Risco'}
          item={itemAtual}
          onClose={handleCloseEdit}
          labelCancelar="label.cancelar"
          labelAlterar="label.excluir"
          restricoesModel={restricoesModel}
        />
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleAssistenteVirtualClick = async () => {
    const riscoId =
      id ||
      item?.id ||
      (modelProp && modelProp.getModel('id') && modelProp.getModel('id').value);

    const infoPrompt = await http.post(`/Risco/GetInfoInsight`, {
      riscoId: riscoId,
    });

    const promptCausas = intl
      .formatMessage({ id: 'promptInsightRisco' })
      .replace(
        /{risco}|{riscos}|{NomeDoRisco}|{AreaDoRisco}|{ProbabilidadeResidual}|{ImpactoResidual}|{TratamentoDefinido}|{PlanoDeAcao}|{ListagemCausas}|{ListagemConsequências}|{ListaControlesPreventivos}|{ListaControlesCorretivos}/gi,
        function (matched) {
          switch (matched) {
            case '{risco}':
              return resources.risco;
            case '{riscos}':
              return resources.riscos;
            case '{NomeDoRisco}':
              return infoPrompt?.data?.nomeDoRisco;
            case '{AreaDoRisco}':
              return infoPrompt?.data?.areaDoRisco;
            case '{ProbabilidadeResidual}':
              return infoPrompt?.data?.probabilidadeResidual;
            case '{ImpactoResidual}':
              return infoPrompt?.data?.impactoResidual;
            case '{TratamentoDefinido}':
              return infoPrompt?.data?.tratamentoDefinido;
            case '{PlanoDeAcao}':
              return infoPrompt?.data?.planoDeAcao;
            case '{ListagemCausas}':
              return infoPrompt?.data?.listagemCausas;
            case '{ListagemConsequências}':
              return infoPrompt?.data?.listagemConsequências;
            case '{ListaControlesPreventivos}':
              return infoPrompt?.data?.listaControlesPreventivos;
            case '{ListaControlesCorretivos}':
              return infoPrompt?.data?.listaControlesCorretivos;
          }
        }
      );

    const msgConsultoraVirtualActioDesvio = intl
      .formatMessage({
        id: 'labelRiscos',
      })
      .replace('{riscos}', capitalizeFirstLetter(resources.riscos));

    ContentManager.addContent(
      <AssistenteVirtual
        user={user}
        prompt={promptCausas}
        title={msgConsultoraVirtualActioDesvio}
        interactionType={TIPO_INTERACAO_SOPHIE.INSIGHTS_RISCO}
      />
    );
  };

  const handleCloseEditUrl = () => {
    const { from } = location.state || {};

    if (from) history.push(from);
    else history.push(`/gerenciar/risco`);
  };

  const handleEnviarParaAprovacao = async (
    modelValue,
    formValid,
    showAllErrors,
    handleClose
  ) => {
    if (enviandoAprovacaoRef.current) return;

    if (!formValid) {
      showAllErrors();
      return;
    }

    enviandoAprovacaoRef.current = true;
    setEnviandoAprovacao(true);

    try {
      await http.post(`Risco/EnviarParaAprovacao`, {
        model: modelValue,
        parameters: { enviarParaAprovacao: true },
        isNew: !(modelValue.id > 0),
      });

      setForceRefresh(true);

      ContentManager.addContent(
        <Alert
          message={intl.formatMessage(
            { id: 'labelEnvioRiscoAprovacaoSucesso' },
            { risco: resources.risco }
          )}
          type="success"
          handleClose={handleClose}
        />
      );
    } catch (error) {
      enviandoAprovacaoRef.current = false;
      setEnviandoAprovacao(false);

      const status = error.response?.status;
      if (status === 400 || status === 404) {
        const message =
          status === 404
            ? intl.formatMessage({
                id: 'itemNaoEncontrado',
              })
            : intl.formatMessage({
                id: 'msgAprovacaoDadosInvalidos',
              });

        errorHandler({ response: { status, data: { errorMessage: message } } });
      } else {
        errorHandler(error);
      }
    }
  };

  const renderButtonsEnd = (
    modelValue,
    isNovo,
    formValid,
    showAllErrors,
    handleClose,
    handleSaveBeforeSave,
    isLoading
  ) => {
    const statusId = Number(modelValue?.status?.id);
    const aguardandoPrimeiroEnvioAprovacao =
      statusId === STATUS_ITEM.EM_PLANEJAMENTO &&
      !modelValue?.existeFluxoAprovacao;
    const aguardandoReenvioAprovacao =
      statusId === STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO;
    const podeEnviarParaAprovacao =
      (aguardandoPrimeiroEnvioAprovacao || aguardandoReenvioAprovacao) &&
      modelValue?.fluxoAprovacao &&
      modelValue?.pendenteAprovacao == false;

    if (!podeEnviarParaAprovacao) {
      return [];
    }

    return [
      <Button
        key="btnEnviarParaAprovacao"
        disabled={!formValid || enviandoAprovacao || isLoading}
        onClick={() =>
          handleEnviarParaAprovacao(
            modelValue,
            formValid,
            showAllErrors,
            handleClose
          )
        }
        className="mr-2"
      >
        <div className="d-flex align-items-center">
          <div className={enviandoAprovacao ? 'pr-1' : ''}>
            {intl.formatMessage({ id: 'enviarParaAprovacao' })}
          </div>
          {enviandoAprovacao && <Spinner color="light" size="sm" />}
        </div>
      </Button>,
    ];
  };

  const showErrorsCustom = (formValue, isNew) => {
    const aguardandoPrimeiroEnvioAprovacao =
      formValue.status?.id == STATUS_ITEM.EM_PLANEJAMENTO &&
      !formValue.existeFluxoAprovacao;

    if (
      formValue.fluxoAprovacao &&
      (formValue.pendenteAprovacao ||
        formValue.status?.id == STATUS_ITEM.REPROVADO ||
        aguardandoPrimeiroEnvioAprovacao)
    )
      return false;

    if (
      !isNew &&
      configuracao?.associarControleCausaConsequencia &&
      configuracao?.associacaoControleCausaConsequenciaObrigatoria
    ) {
      const hasCausaComControle =
        formValue.causasRisco &&
        Array.isArray(formValue.causasRisco) &&
        formValue.causasRisco.some(
          (causa) =>
            causa.hasChildren || (causa.children && causa.children.length > 0)
        );

      const hasConsequenciaComControle =
        formValue.consequenciasRisco &&
        Array.isArray(formValue.consequenciasRisco) &&
        formValue.consequenciasRisco.some(
          (consequencia) =>
            consequencia.hasChildren ||
            (consequencia.children && consequencia.children.length > 0)
        );

      // Se não houver pelo menos 1 causa && 1 consequência com controle, exibe a mensagem
      if (!hasCausaComControle || !hasConsequenciaComControle) {
        ContentManager.addContent(
          <Alert
            title={<FormattedMessage id="erro" />}
            message={capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.ObrigatorioVincularControleCausaConsequencia' },
                {
                  pontodecontrole: lowerCaseFirstLetter(
                    resources.pontodecontrole
                  ),
                }
              )
            )}
          />
        );
        return true;
      }
    }

    return false;
  };

  const isNew = !((id && id > 0) || (item && item.id > 0));

  const showActionsSave =
    item?.status?.id == STATUS_ITEM.REPROVADO ? false : true;

  return (
    <div>
      <Edit
        {...props}
        forceRefresh={forceRefresh}
        showExport={false}
        showActionsEnd={showActionsSave}
        showSaveClose={showActionsSave}
        showSave={showActionsSave}
        disabled={disabledEdit}
        showIconDelete={showDelete}
        handleClose={
          location && id > 0 ? handleCloseEditUrl : props.handleClose
        }
        resourceSophieToolTip={'tooltipSophieInsightRisco'}
        handleAssistenteVirtualClick={!isNew && handleAssistenteVirtualClick}
        renderButtonActions={
          configuracao?.usarFluxoAprovacaoBelt ? renderButtonsEnd : null
        }
        renderActions={(closeModal) => {
          return (
            <div className="d-inline" style={{ height: '20px' }}>
              <UncontrolledDropdown
                group
                direction="right"
                className="ml-2 d-inline"
                key="indicador"
              >
                <DropdownToggle color="btn-outline-secondary">
                  <LucideIcon icon="dots-vertical" />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItemRisco
                    handleCloseModal={closeModal}
                    showEdit={item?.permissions?.allowEdit}
                    exibirEdicao={item?.permissions?.allowEdit}
                    item={item}
                    resources={resources}
                  />
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        }}
        url="/Risco"
        parameters={{ tipoId: 6, ...parameters }}
        titleField="nome"
        title={
          !isNew
            ? capitalizeFirstLetter(resources.risco)
            : capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'labelAdicionarRisco' },
                  { risco: lowerCaseFirstLetter(resources.risco) }
                )
              )
        }
        ignoreResourceTitle
        styleTitle={{ fontSize: '22px', fontFamily: 'nunito' }}
        HeaderCustomComponent={<Graficos />}
        formComponent={FormEdit}
        width="85%"
        height="90%"
        minHeight="30%"
        schema={Schema}
        afterSave={handleSaved}
        configuracao={configuracao}
        configuracaoEvento={configuracaoEvento}
        id={id}
        item={item ? item : id && id > 0 ? { id: id } : null}
        showDelete={showDelete}
        onDeleting={handleDeleteClick}
        resources={resources}
        showErrorsCustom={(formValue) => showErrorsCustom(formValue, isNew)}
      />
    </div>
  );
};

export default RiscoEdit;
